import { render, staticRenderFns } from "./popup-permission.vue?vue&type=template&id=b445a854&"
import script from "./popup-permission.vue?vue&type=script&lang=ts&"
export * from "./popup-permission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports